import { render, staticRenderFns } from "./EditCarDialog.vue?vue&type=template&id=457e831f&lang=pug&"
import script from "./EditCarDialog.vue?vue&type=script&lang=ts&"
export * from "./EditCarDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports